/** Deterministic line icons for DeckOS root navigation (Gate 2B). */

type IconProps = { active?: boolean };

const stroke = {
  fill: "none" as const,
  stroke: "currentColor",
  "stroke-width": 1.95,
  "stroke-linecap": "round" as const,
  "stroke-linejoin": "round" as const,
};

export function NavIconChipmap(_props: IconProps) {
  return (
    <svg class="nav-icon" viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="7" cy="7" r="2.2" {...stroke} />
      <circle cx="17" cy="7" r="2.2" {...stroke} />
      <circle cx="7" cy="17" r="2.2" {...stroke} />
      <circle cx="17" cy="17" r="2.2" {...stroke} />
      <circle cx="12" cy="12" r="2.4" {...stroke} />
      <path
        d="M9 8.2 10.4 10.4M14 8.2 13 10.4M9 15.8 10.4 13.6M14 15.8 13 13.6"
        {...stroke}
      />
    </svg>
  );
}

export function NavIconArcopedia(_props: IconProps) {
  return (
    <svg class="nav-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M5 6.5c3.2-1.8 5.8-.6 7 1.2 1.2-1.8 3.8-3 7-1.2v11.2c-3.2-1.6-5.8-.6-7 1-1.2-1.6-3.8-2.6-7-1V6.5z"
        {...stroke}
      />
      <path d="M12 7.8v11" {...stroke} />
    </svg>
  );
}

export function NavIconManifest(_props: IconProps) {
  return (
    <svg class="nav-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path d="m12 4 7 4v8l-7 4-7-4V8z" {...stroke} />
      <path d="M12 12 19 8M12 12 5 8M12 12v8" {...stroke} />
    </svg>
  );
}

export function NavIconSync(_props: IconProps) {
  return (
    <svg class="nav-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M7.5 8.2A6.2 6.2 0 0 1 18 10.5" {...stroke} />
      <path d="M16.5 15.8A6.2 6.2 0 0 1 6 13.5" {...stroke} />
      <path d="M16.2 7.2 18.2 10.4 15 11.2" {...stroke} />
      <path d="M7.8 16.8 5.8 13.6 9 12.8" {...stroke} />
    </svg>
  );
}

export const navIconMap = {
  CHIPMAP: NavIconChipmap,
  ARCOPEDIA: NavIconArcopedia,
  MANIFEST: NavIconManifest,
  SYNC: NavIconSync,
} as const;
